import { useState } from "react";
import { Menu, X } from "lucide-react"; // Optional: lucide-react icons for hamburger menu

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="bg-gray-900 text-white sticky top-0 z-50">
      <div className="flex justify-between items-center px-6 py-4 max-w-7xl mx-auto">
        <a href="/app.js"><h1 className="text-lg font-bold">N. CHANDU</h1></a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex gap-6 text-sm">
          <li><a href="#experience" className="hover:text-red-500">Experience</a></li>
          <li><a href="#skills" className="hover:text-red-500">Skills</a></li>
          <li><a href="#projects" className="hover:text-red-500">Projects</a></li>
          <li><a href="#resume" className="hover:text-red-500">Resume</a></li>
          <li><a href="#contact" className="hover:text-red-500">Contact</a></li>
        </ul>

        {/* Hamburger Menu */}
        <button className="md:hidden" onClick={toggleMenu}>
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <ul className="flex flex-col gap-4 text-sm px-6 pb-4 md:hidden bg-gray-800">
          <li><a href="#experience" className="hover:text-red-500" onClick={toggleMenu}>Experience</a></li>
          <li><a href="#skills" className="hover:text-red-500" onClick={toggleMenu}>Skills</a></li>
          <li><a href="#projects" className="hover:text-red-500" onClick={toggleMenu}>Projects</a></li>
          <li><a href="#resume" className="hover:text-red-500" onClick={toggleMenu}>Resume</a></li>
          <li><a href="#contact" className="hover:text-red-500" onClick={toggleMenu}>Contact</a></li>
        </ul>
      )}
    </nav>
  );
}
